export default {
  title: "Estimation de la valeur d'un post",
  description: "Calcul basé sur le taux d'engagement et la taille de communauté sur les trois derniers mois.",
  no_price: "Nous ne disposons pas d'assez de données pour pouvoir estimer la valeur de vos posts sur ce réseau.",
};
